module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "box",
    class: [("icon-" + _vm.icon), ("size-" + _vm.size)],
    attrs: {
      "data-stats-attribute": _vm.icon
    }
  }, [_c('div', {
    staticClass: "box-stat"
  }, [_c('div', {
    staticClass: "box-number"
  }, [_vm._v(_vm._s(_vm.value))]), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.description) ? _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()])]), (_vm.details) ? _c('div', {
    staticClass: "box-details"
  }, [(_vm.showDetails === false) ? _c('div', {
    staticClass: "view-details",
    on: {
      "click": _vm.toggleShowDetails
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pos.campaign.stats-see-details')))]), _c('icon', {
    attrs: {
      "name": "chevron-down",
      "small": true
    }
  })], 1) : _c('div', {
    staticClass: "close-details",
    on: {
      "click": _vm.toggleShowDetails
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pos.campaign.stats-close-details')))]), _c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1), (_vm.showDetails) ? _c('div', {
    staticClass: "details"
  }, _vm._l((_vm.details), function(detail) {
    return _c('div', {
      staticClass: "detail"
    }, [_c('div', {
      staticClass: "detail-number"
    }, [_vm._v(_vm._s(_vm.$t('fn.number', {
      value: detail.value
    })))]), _c('div', {
      staticClass: "detail-title"
    }, [_vm._v(_vm._s(_vm.$t("fn.complex.stats", {
      name: detail.name
    })))])])
  })) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36686fc8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/campaign-stats/stats-info/StatsInfo.vue
// module id = 2033
// module chunks = 1